import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify'; // Check if the path to your Vuetify plugin is correct
import VueRouter from 'vue-router'
import router from './router'
import AOS from "aos";
import "aos/dist/aos.css";

AOS.init({
  offset: 100,
  duration: 1000,
  easing: "ease",
});



Vue.use(VueRouter)

new Vue({
  // Ensure that vuetify is properly set up as a plugin
  vuetify,

  router,
  render: h => h(App)
}).$mount('#app');

